import * as React from 'react'

import { ChevronDownIcon } from 'lucide-react'
import { classList } from 'react-classlist-helper'

// localization: no text to translate

interface IProps {
  onClick?: () => void
}

export default function CaretDownSelectorIcon({
  onClick,
}: IProps): JSX.Element {
  const handleClick = React.useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation()
      onClick?.()
    },
    [onClick],
  )

  return (
    <div
      className={classList({
        'absolute no-grow text light': true,
        'unclickable-element': !onClick,
        pointer: !!onClick,
      })}
      style={{ right: 8, top: '50%', transform: 'translateY(-50%)' }}
      onClick={onClick ? handleClick : undefined}
    >
      <ChevronDownIcon size={16} className="tw:block" />
    </div>
  )
}
